import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';

function FormFooter({ t, submitHandler, isLoading }) {
  return (
    <div className="m-portlet__foot m-portlet__foot--fit">
      <div className="m-form__actions profile-save-form-container">
        <button
          type="submit"
          className={`btn btn-accent m-btn m-btn--air m-btn--custom loader-button ${
            isLoading ? ' m-loader m-loader--right m-loader--light' : ''
          }`}
          disabled={isLoading}
          onClick={submitHandler}
        >
          {t('save')}
        </button>
      </div>
    </div>
  );
}

FormFooter.propTypes = {
  t: PropTypes.func.isRequired,
  submitHandler: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

FormFooter.defaultProps = {
  isLoading: false,
};

export default translate(FormFooter);
